import { AuthState } from "@okta/okta-auth-js";
import { Server } from "../../Shared/Util/Server";
import { formatRequestParams } from "./RequestFormatting";

export interface IUpdateRequestParams {
  pageNumber: number;
  pageSize: number;
  skip: number;
  filter: { filters: any[] };
  orderBy: string;
}

export function fetchUpdates(
  auth: AuthState,
  requestParams: IUpdateRequestParams
): Promise<Api.INotificationsResponse|null> {
  const updatedParams = formatRequestParams(requestParams);
  let url = `/v1/notification?pageNumber=${updatedParams.pageNumber}&resultsPerPage=${updatedParams.pageSize}&orderBy=${updatedParams.orderBy}`;
  
  if (updatedParams.filter.filters) {
    url += `&filter=${updatedParams.filter.filters}`;
  }
  
  return Server.get<Api.INotificationsResponse>(url, auth);
}
